import { useMutation } from '@apollo/client/react'
import { graphql } from '../__generated__'

const mutations = {
  ReportExportLog: graphql(`
    mutation ReportExportLog($input: CreateExportActivityLogItemInput!) {
      createExportActivityLogItem(input: $input) {
        success
      }
    }
  `),
}

export const useReportExportLogger = () => {
  const [log] = useMutation(mutations.ReportExportLog)

  const logExport = (caseIds: string[]) =>
    log({
      variables: { input: { caseIds } },
    })

  return {
    logExport,
  }
}
